import styled from '@emotion/styled';
import { shouldForwardProps } from '../../utils';
import { Box } from '@mui/material';

const SliderContainer = styled(Box)`
    width: 100%;
    max-width: 100%;
    overflow: hidden;
`;

export const SLIDER_GAP = 24;

const CarouselContent = styled(Box)`
    padding-top: ${({ theme }) => theme.spacing(3)};
    margin-bottom: ${({ theme }) => theme.spacing(4)};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }
`;

const SliderDotsContainer = styled(Box, shouldForwardProps)`
    display: flex;
    align-self: center;
    width: fit-content;
    .MuiMobileStepper-dots {
        gap: ${({ theme }) => theme.spacing(1)};
        height: 100%;
        align-items: center;
    }
    .MuiMobileStepper-dotActive {
        background-color: ${({ theme }) => theme.colors.onPrimaryContainer};
        height: 12px;
        width: 12px;
    }
`;

const ImageSliderContainer = styled(Box)`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const ImageSwiperContainer = styled(Box)`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
`;

const ImageNavigationContainer = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
`;

export { SliderContainer, CarouselContent, SliderDotsContainer, ImageSliderContainer, ImageSwiperContainer, ImageNavigationContainer };
